import React from "react";
import { CompactPicker } from "react-color";
import "./ColorSelector.css";

const ColorSelector = ({ colors, colorHex, colorChangeHandler }) => {
  const handleColorChange = (color) => {
    colorChangeHandler(color.hex);
  };

  return (
    <CompactPicker
      color={colorHex}
      colors={colors}
      onChange={(color) => {
        handleColorChange(color);
      }}
      className="compact-color-picker-main"
    />
  );
};

export default ColorSelector;
